import { render, staticRenderFns } from "./customTabbar.vue?vue&type=template&id=5e7f5ef4&scoped=true"
import script from "./customTabbar.vue?vue&type=script&lang=js"
export * from "./customTabbar.vue?vue&type=script&lang=js"
import style0 from "./customTabbar.vue?vue&type=style&index=0&id=5e7f5ef4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7f5ef4",
  null
  
)

export default component.exports